export const bodyEnergySystems = {
    heading: "Understanding the Body's Energy Systems",
    content: [
        'Just like Reiki, Body Coding recognizes that everything in the universe is made of energy.',
        'When energy flows freely, communication between mind, body, and spirit is clear and harmonious.',
        'When energy becomes blocked or imbalanced, it creates disharmony — which can manifest as physical symptoms, emotional tension, or mental fatigue.',
        'Releasing these trapped energies restores balance, clarity, and the natural flow of life force energy throughout the system.',
    ],
}